import React from "react";
import { Control, Controller, FieldValues, Path } from "react-hook-form";
import { useTranslation } from "react-i18next";

import { useGetNaceSections } from "@api";
import { Autocomplete, TextField } from "@components/base";
import { useUserStore } from "@store/user";

interface NaceSectionProps<TFieldValues extends FieldValues> {
  control: Control<TFieldValues>;
}

const NaceSection = <TFieldValues extends FieldValues>({
  control,
}: NaceSectionProps<TFieldValues>): JSX.Element | null => {
  const { t } = useTranslation();
  const { user } = useUserStore();
  const { naceSections, naceSectionsEnabled } = useGetNaceSections(user);

  if (!naceSectionsEnabled) {
    return null;
  }

  return (
    <Controller
      control={control}
      name={"naceSectionId" as Path<TFieldValues>}
      render={({ field }): React.ReactElement => (
        <Autocomplete
          options={naceSections ?? []}
          getOptionLabel={(option) => option.name}
          isOptionEqualToValue={(a, b) => a.id === b.id}
          value={
            naceSections?.find((s) => s.id === field.value) ?? null
          }
          onChange={(_, option) => field.onChange(option?.id ?? "")}
          renderInput={(params) => (
            <TextField
              {...params}
              label={t("entitiesManagement.entityEditor.naceSection")}
            />
          )}
        />
      )}
    />
  );
};

export default NaceSection;
